import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import HeaderCustom from "../../../components/HeaderCustom";
import { Backdrop, Box, CircularProgress, Container } from "@mui/material";
import FitroUserApps from "./components/FitroUserApps";
import { getFiltrarUsuarios } from "../../../api/ApiService";
import { useNavigate } from "react-router-dom";
import UsuariosTableComponent from "./components/UsuariosTableComponent";



function UsuariosAppPage() {
    const [loadingCargar, setLoadingCargar] = useState(false);
    const [loading, setLoading] = useState(false);

    const [nameCedula, setNameCedula] = useState('');
    const [email, setEmail] = useState('');

    const [estadoSearch, setEstadoSearch] = useState('');
    const [estadoSelected, setEstadoSelected] = useState({ label: 'Todos', value: "todos", id: 1 });


    const [verificadoPorEmailSearch, setVerificadoPorEmailSearch] = useState('');
    const [verificadoPorEmailSelected, setVerificadoPorEmailSelected] = useState({ label: 'Todos', value: "todos", id: 1 });


    const [tipoSearch, setTipoSearch] = useState('');
    const [tipoSelected, setTipoSelected] = useState({ label: 'Todos', value: "todos", id: 1 });

    const [userTesterSearch, setUserTesterSearch] = useState('');
    const [userTesterSelected, setUserTesterSelected] = useState({ label: 'Todos', value: "todos", id: 1 });

    const [dataUsuarios, setDataUsuarios] = useState([]);

    const [metaPaginacion, setMetaPaginacion] = useState({
        current_page: 1,
        per_page: 10,
        total: 0,
        last_page: 1
    });
    const [perPage, setPerPage] = useState(10);

    const requestIdRef = useRef(0);








    const stateToken = useSelector(state => state.reducerGlobal.token);
    // console.log("stateToken", stateToken?.body?.token);

    let history = useNavigate();




    useEffect(() => {
        const timeOutId = setTimeout(() => {
            if (nameCedula.length > 2 || email.length > 2) {

                handleApiFiltrarUsuariosTituloEstado(nameCedula);
            } else {
                handleApiFiltrarUsuarios(1);
            }
        }, 1500);
        return () => clearTimeout(timeOutId);
    }, [stateToken, nameCedula, email, estadoSelected, verificadoPorEmailSelected, tipoSelected, userTesterSelected, perPage]);



    //============================================================ funcion para filtrar por estado y nombre
    const handleApiFiltrarUsuariosTituloEstado = (titulo) => {
        //  url: URL + `/filtrar/usuario-app?term=${body.term}&email=${body.email}&verificacion=${body.verificacion}&estado=${body.estado}&tipo=${body.tipo}&tester=${body.tester}&page=${body.page}&per_page=${body.per_page}`,
        let body = {
            page: 1,
            per_page: perPage,
            estado: estadoSelected?.value === undefined ? "" : estadoSelected?.value,
            term: titulo,
            email: email,
            verificacion: verificadoPorEmailSelected?.value === undefined ? "" : verificadoPorEmailSelected?.value,
            tipo: tipoSelected?.value === undefined ? "" : tipoSelected?.value,
            tester: userTesterSelected?.value === undefined ? "" : userTesterSelected?.value,

        };
        console.log("body-handleApiFiltrarLocales", body);


        setLoadingCargar(true);

        const requestId = ++requestIdRef.current;

        getFiltrarUsuarios(stateToken?.access_token, body)
            .then(response => {
                if (requestId !== requestIdRef.current) return;
                // console.log("response==>getFiltrarUsuarios", response);

                setLoadingCargar(false);
                // setMetaPaginacion(response.meta);

                if (response.data.length > 0) {
                    setDataUsuarios(response.data);
                    setLoading(true);
                } else {
                    setDataUsuarios([]);
                    setLoading(true);
                }

                setMetaPaginacion({
                    current_page: response?.current_page,
                    per_page: response?.per_page,
                    total: response?.total,
                    last_page: response?.last_page
                });


            })
            .catch(error => {
                if (requestId !== requestIdRef.current) return;
                console.log("error==>getFiltrarUsuarios", error);
                setDataUsuarios([]);
                setLoading(true);
                setLoadingCargar(false);
            })
    };



    //============================================================ funcion para filtrar por estado y nombre
    const handleApiFiltrarUsuarios = (page = 1) => {

        let body = {
            page: page,
            per_page: perPage,
            estado: estadoSelected?.value === undefined ? "" : estadoSelected?.value,
            term: nameCedula,
            email: email,
            verificacion: verificadoPorEmailSelected?.value === undefined ? "" : verificadoPorEmailSelected?.value,
            tipo: tipoSelected?.value === undefined ? "" : tipoSelected?.value,
            tester: userTesterSelected?.value === undefined ? "" : userTesterSelected?.value,

        };
        // console.log("body-handleApiFiltrarLocales", body);


        setLoadingCargar(true);

        const requestId = ++requestIdRef.current;

        getFiltrarUsuarios(stateToken?.access_token, body)
            .then(response => {
                if (requestId !== requestIdRef.current) return;
                // console.log("response==>getFiltrarUsuarios", response);

                setLoadingCargar(false);
                // setMetaPaginacion(response.meta);

                if (response.data.length > 0) {
                    setDataUsuarios(response.data);
                    setLoading(true);
                } else {
                    setDataUsuarios([]);
                    setLoading(true);
                }

                setMetaPaginacion({
                    current_page: response?.current_page,
                    per_page: response?.per_page,
                    total: response?.total,
                    last_page: response?.last_page
                });


            })
            .catch(error => {
                if (requestId !== requestIdRef.current) return;
                console.log("error==>getFiltrarUsuarios", error);
                setDataUsuarios([]);
                setLoading(true);
                setLoadingCargar(false);
            })
    };





























    //=============================================funcion para capturar el name y cedula
    const handleNameCedula = (e) => {
        setNameCedula(e);
    }

    //=============================================funcion para capturar el email
    const handleEmail = (e) => {
        setEmail(e);
    };













    //=============================================funcion para buscar el estado
    const handleEstadoSearch = (event) => {
        console.log("event", event);
        setEstadoSearch(event);
    };

    //=========================================================funcion para seleccionar el estado
    const handleEstadoSelected = (value) => {
        console.log("value-handleEstadoSelected: ", value);
        setEstadoSelected(value);

    };












    //=============================================funcion para buscar el estado de verificado por email
    const handleVerificadoPorEmailSearch = (event) => {
        console.log("event", event);
        setVerificadoPorEmailSearch(event);
    };

    //=========================================================funcion para seleccionar el estado de verificado por email
    const handleVerificadoPorEmailSelected = (value) => {
        // console.log("value-handleVerificadoPorEmailSelected: ", value);
        setVerificadoPorEmailSelected(value);

    };











    //=============================================funcion para buscar el tipo
    const handleTipoSearch = (event) => {
        // console.log("event", event);
        setTipoSearch(event);
    };

    //=========================================================funcion para seleccionar el tipo
    const handleTipoSelected = (value) => {
        // console.log("value-handleTipoSelected: ", value);
        setTipoSelected(value);
    };














    //=============================================funcion para buscar el user tester
    const handleUserTesterSearch = (event) => {
        console.log("event", event);
        setUserTesterSearch(event);
    };


    //=========================================================funcion para seleccionar el tipo
    const handleUserTesterSelected = (value) => {
        // console.log("value-handleUserTesterSelected: ", value);
        setUserTesterSelected(value);
    };


    //=============================================funcion para editar
    const handleEditClick = (item) => {
        console.log('Edit', item);
        history('/app/admin/usuarios-app/editar/' + item?.id);
    };



    //=============================================funcion para ver detalles
    const handleDetalleClick = (item) => {
        console.log('Detalle', item);
        history('/app/admin/usuarios-app/detalle/' + item?.id);
    };



    //=============================================funcion para actualizar la contraseña
    const handleResetPassword = (item) => {
        console.log('Reset Password', item);
        history('/app/admin/usuarios-app/detalle-reset/' + item?.id);
    };




    const handlePerPageChange = (newPerPage) => {
        setPerPage(newPerPage);
    };



    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-6">
                {loading ? (
                    <div>
                        <FitroUserApps
                            nameCedula={nameCedula}
                            handleNameCedula={handleNameCedula}

                            email={email}
                            handleEmail={handleEmail}

                            estadoSelected={estadoSelected}
                            handleEstadoSearch={handleEstadoSearch}
                            handleEstadoSelected={handleEstadoSelected}


                            verificadoPorEmailSelected={verificadoPorEmailSelected}
                            handleVerificadoPorEmailSearch={handleVerificadoPorEmailSearch}
                            handleVerificadoPorEmailSelected={handleVerificadoPorEmailSelected}



                            tipoSelected={tipoSelected}
                            handleTipoSearch={handleTipoSearch}
                            handleTipoSelected={handleTipoSelected}



                            userTesterSelected={userTesterSelected}
                            handleUserTester={handleUserTesterSearch}
                            handleUserTesterSelected={handleUserTesterSelected}
                        />

                        <div>
                            <UsuariosTableComponent
                                data={dataUsuarios}
                                metaPaginacion={metaPaginacion}
                                onPageChange={handleApiFiltrarUsuarios}
                                perPage={perPage}
                                onPerPageChange={handlePerPageChange}
                                handleEditarItem={handleEditClick}
                                handleDetalleItem={handleDetalleClick}
                                handleResetPassword={handleResetPassword}
                            // handleOpenModalDeleteEvento={handleOpenModalDeleteEvento}
                            />
                        </div>


                    </div>
                ) : (
                    <div className="bg-white rounded-xl shadow-md p-8">
                        <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                        <div className="space-y-4">
                            <div className="h-10 bg-gray-200 rounded animate-pulse" />
                            <div className="h-10 bg-gray-200 rounded animate-pulse" />
                            <div className="h-24 bg-gray-200 rounded animate-pulse" />
                        </div>
                    </div>
                )}


                <Backdrop open={loadingCargar} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
                    <CircularProgress color="inherit" />
                </Backdrop>
            </div>
        </HeaderCustom>
    );
}

export default UsuariosAppPage;